// ========================================
// 📄 src/contexts/NotificationContext.jsx (FIX BLANK SCREEN)
// ========================================
import React, { createContext, useContext, useState } from "react";
import NotificationContainer from "../components/common/NotificationContainer";

const NotificationContext = createContext(undefined);

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error("useNotification must be used within NotificationProvider");
  }
  return context;
};

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);

  const addNotification = (partial) => {
    const id = Date.now() + Math.random();
    const notification = {
      id,
      type: partial.type || "info",
      title: partial.title || "",
      message: partial.message || "",
      duration: partial.duration ?? 5000,
    };
    setNotifications((prev) => [...prev, notification]);
    return id;
  };

  const removeNotification = (id) => {
    setNotifications((prev) => prev.filter((n) => n.id !== id));
  };

  const clearAll = () => setNotifications([]);

  const showNotification = (type, title, message, duration) =>
    addNotification({ type, title, message, duration });
  const showSuccess = (title, message, duration) =>
    showNotification("success", title, message, duration);
  const showError = (title, message, duration) =>
    showNotification("error", title, message, duration);
  const showWarning = (title, message, duration) =>
    showNotification("warning", title, message, duration);
  const showInfo = (title, message, duration) =>
    showNotification("info", title, message, duration);

  const value = {
    notifications,
    addNotification,
    removeNotification,
    clearAll,
    showNotification,
    showSuccess,
    showError,
    showWarning,
    showInfo,
  };

  return (
    <NotificationContext.Provider value={value}>
      {children}
      <NotificationContainer />
    </NotificationContext.Provider>
  );
};

export default NotificationContext;
